module.exports = __webpack_public_path__ + "media/VideoCompressed.a1075a08.mp4";